import { Language } from './language';

export default class LanguageSelectionConfiguration {
  availableLanguages: Language[];
  selectedLanguages: Language[];
  multiple: boolean;
  showBookAvailability: boolean;
  showClearButton: boolean;
}
